'use client';
import { i18nConfig } from '@/i18n/config';
import { useCurrentLocale as useCurrentLocaleNextRouter } from 'next-i18n-router/client';

export function useCurrentLocale() {
  return useCurrentLocaleNextRouter(i18nConfig) || i18nConfig.defaultLocale;
}
